import React from 'react';
import {styled} from '@mui/material/styles';
import {AlreadyRegisteredComponentProps} from '@practicegenius/register-account/src/screens/AlreadyRegistered';
import {globalRoutes} from '../../../shared/globalRoutes';

const UnderlineLink = styled('a')({
  marginBottom: 8,
  alignSelf: 'flex-start',
  '&:hover': {
    textDecoration: 'underline',
  },
});

export const AlreadyRegisteredContent: React.FC<AlreadyRegisteredComponentProps> =
  ({lang, message, links, onUseDifferentEmailClick, email}) => (
    <>
      <p>{message}</p>
      {links.register && (
        <UnderlineLink onClick={onUseDifferentEmailClick}>
          {lang.buttons.text.register}
        </UnderlineLink>
      )}
      {links.forgot_password && (
        <UnderlineLink
          href={`${globalRoutes.login.forgotPassword}?user=${encodeURIComponent(
            email
          )}`}
        >
          {lang.buttons.text.forgotPassword}
        </UnderlineLink>
      )}
    </>
  );
